module.exports = __webpack_public_path__ + "img/page-09.4e1bf680.jpg";